/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Packaging_StatsInputs */

const vi_nav_packaging_stats = /** @type {(inputs: Nav_Packaging_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê`)
};

/**

* @param {Nav_Packaging_StatsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_packaging_stats = /** @type {((inputs?: Nav_Packaging_StatsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Packaging_StatsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_packaging_stats(inputs)
});